import React, { useEffect, useState } from 'react';
import { Box, Dialog, IconButton, Stack, Switch, Tooltip, Typography } from '@mui/material';
import { IClient } from "@ontime/types";
import ClientList from '../client/ClientList';
import ClearIcon from '@mui/icons-material/Clear';
import AppointmentGuestForm from './AppointmentGuestForm';
import { IAppointment } from "@ontime/types";
import AppointmentByClientIdForm from './AppointmentClientForm';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import CustomDialogTitle from '../../customComponents/CustomDialogTitle';
import CustomDialogContent from '../../customComponents/CustomDialogContent';
import { useTheme, useMediaQuery } from '@mui/material';

const AppointmentDialog: React.FC<{
    state: { open: boolean; startDateTime?: string; existData?: IAppointment | null; };
    closeAppointmentDialog: (input?: IAppointment) => void;
    AllAppointment: IAppointment[] | []
}> = ({ state, closeAppointmentDialog, AllAppointment }) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const handleClose = () => {
        formOpen.open ? setFormOpen({ open: false }) : closeAppointmentDialog();
    }

    const handleClientClose = () => {
        setIsGuest(true);
    }

    const [isGuest, setIsGuest] = useState(true);

    const [loading, setLoading] = useState(false);

    const [formOpen, setFormOpen] = useState<{ open: boolean; client?: IClient | null }>({ open: false });

    const [selectedClient, setSelectedClient] = useState<IClient | null>();

    const handleSelect = (input: IClient) => {
        setSelectedClient(input);
    }

    const closeAppointmentGuestForm = (input?: IAppointment) => {
        closeAppointmentDialog(input)
    };

    const closeAppointmentByClientIdForm = (input?: IAppointment) => {
        closeAppointmentDialog(input)
    };

    useEffect(() => {
        if (state.existData && state.open) {
            setIsGuest(state.existData.clientId ? false : true)

            if (state.existData.clientId) {
                //todo
                // setSelectedClient(state.existData.client)
            }
            else (
                setSelectedClient(null)
            )
        }

    }, [state.existData]);


    useEffect(() => {
        if (state.open) {
            setSelectedClient(null);
            setIsGuest(true);
            setLoading(false);
        }

    }, [state.open]);

    return (
        <Dialog
            open={state.open}
            onClose={() => handleClose()}
            fullWidth
            fullScreen={fullScreen}
        >
            <CustomDialogTitle handleClose={handleClose} title='New Appointment' loading={loading} />
            {!(selectedClient?.clientId) && !isGuest &&
                <ClientList state={(!(selectedClient?.clientId) && !isGuest) ? 'mount' : 'unmount'} loading={loading} setLoading={setLoading} handleSelect={handleSelect} handleClose={handleClientClose} CustomTitle='Select Client' />
            }
            <CustomDialogContent>
                {!state?.existData?.clientId && isGuest &&
                    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                        <Typography>Guest</Typography>
                        <Switch
                            checked={!(isGuest)}
                            onChange={(e) => setIsGuest(!e.target.checked)}
                            disabled={loading}
                        />
                        <Typography>Client</Typography>
                    </Stack>
                }
                {isGuest ?
                    <AppointmentGuestForm
                        AllAppointment={AllAppointment}
                        appointmentInput={state.existData}
                        startDateTime={state.startDateTime ?? ''}
                        closeForm={closeAppointmentGuestForm}
                        loading={loading}
                        setLoading={setLoading}
                    />
                    :
                    (selectedClient?.clientId &&
                        <>
                            <Box display="flex" alignItems="center" gap={0.5} mt={2} height='30px'>
                                <Box display='flex' flexDirection='row'>
                                    <AssignmentIndIcon />
                                 
                                        <Typography variant="body1" gutterBottom>
                                            {`${selectedClient?.firstName}${selectedClient?.lastName ? ` ${selectedClient?.lastName}` : ''}`}
                                        </Typography>
                                    
                                </Box>
                                <IconButton disabled={loading} size='small' onClick={() => setSelectedClient(null)} ><ClearIcon /></IconButton>
                            </Box>
                            <AppointmentByClientIdForm
                                AllAppointment={AllAppointment}
                                appointmentInput={state.existData}
                                startDateTime={state.startDateTime ?? ''}
                                closeForm={closeAppointmentByClientIdForm}
                                selectedClient={selectedClient}
                                loading={loading}
                                setLoading={setLoading}
                            />
                        </>
                    )
                }
            </CustomDialogContent>
        </Dialog>
    );
};

export default AppointmentDialog;